<template>
    <div>
        <my-header
            :title="resource.title"
            isBack
        />

        <div class="bottom-20">
            <video-player :video="video"/>
        </div>

        <div class="content">
            <div class="video-title">{{video.title}}</div>

            <div class="intr">
                <introduction
                    title="内容简介"
                    :logoType="2"
                    :intr="video.description"
                />
            </div>

            <van-divider />

            <div class="bottom-20">
                <action-bar />
            </div>

            <!-- 视频分P -->
            <div class="related bottom-30" v-if="videos && videos.length > 1">
                <div class="list-title bottom-20">
                    <div class="title-logo-tri"></div>
                    章节
                </div>
                <div>
                    <resource-list-hor coverType="video" :list="videos"/>
                </div>
            </div>

            <!-- 相关视频 -->
            <div class="related bottom-30" v-if="relatedVideos && relatedVideos.length">
                <div class="list-title bottom-20">
                    <div class="title-logo-tri"></div>
                    相关视频
                </div>
                <div>
                    <resource-list-hor coverType="video" :list="relatedVideos"/>
                </div>
            </div>

            <!-- 评论区 -->
            <div class="comment">
                <div class="list-title bottom-20">
                    <div class="title-logo-tri"></div>
                    热门评论
                </div>
                <div>
                    <comment-list :item-id="video.vid"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, ref} from 'vue';
import MyHeader from '@/components/myHeader'
import VideoPlayer from '@/components/videoPlayer'
import Introduction from '@/components/introduction'
import ActionBar from '@/components/actionBar'
import ResourceListHor from '@/components/resourceListHor'
import CommentList from '@/components/commentList'
import LoadResource from "@/views/resource/LoadResource";
import {getTopicPageData} from "@/api/CommonApi";
import {randomSelect} from "@/utils/ArrayUtils";
import {calcVideo} from "@/views/personage/CalcResourceHorList";
import AddPointMixin from "@/views/resource/AddPointMixin";

export default {
    name: 'ResourceVideo',
    mixins:[AddPointMixin],
    components: {
        MyHeader,
        VideoPlayer,
        Introduction,
        ActionBar,
        ResourceListHor,
        CommentList
    },
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    provide(){
        return{
            resourceId:computed(() => this.resource.id),
            resourceItemId:computed(() => this.video.vid),
            enableComment:computed(() =>  this.resource.enableComment)
        }
    },
    watch:{
        id(val){
            this.initLoadResource(val,true)
        },
        // 当resource发生变化时
        resource(){
            this.loadRelatedVideo()
        }
    },
    setup(props) {
        const obj = new LoadResource(props.id,true)
        const initLoadResource = (id,fetchContent) => obj.init(id,fetchContent);
        const loadResource = () => obj.loadResource();
        const relatedVideos = ref([])
        /**
         * 推荐相关视频
         */
        function loadRelatedVideo(){
            const r = obj.resource.value
            // 获取栏目code
            const topicCode = r.topicCode
            getTopicPageData(topicCode,{
                page:1,pageSize: 20,orderByClicks:'DESC'
            }).then(res => {
                const result = res.result
                if(!result || !result.records) return;
                // 剔除自己
                const list = result.records.filter(v => v.id !== r.id)
                // 抽取5个
                const selected = randomSelect(list,5)
                relatedVideos.value = calcVideo(selected)
            })
        }

        return {
            relatedVideos,loadRelatedVideo,
            // 服务端响应数据
            resource:obj.resource,
            // 加载数据中
            loading:obj.loading,
            // 初始化，重新加载数据
            initLoadResource,
            // 加载数据
            loadResource,
        }
    },
    computed:{
        // 视频 章节
        videos(){
            const videoItems = this.resource.item
            if(!videoItems || !videoItems.length) return []
            const id = this.resource.id
            const title = this.resource.title
            const cover = this.resource.cover
            const description = this.resource.description
            const list = []
            for(let i = 0; i < videoItems.length; i++){
                const item = videoItems[i]
                list.push({
                    ...item,
                    id:id,
                    vid:item.id,
                    itemId:item.id,
                    videoPath:item.content,
                    path:`/r/video/${id}?p=${i + 1}`,
                    title:item.title || title,
                    cover:item.cover || cover,
                    description:item.description || description || '--',
                })
            }
            return list
        },
        // 当前播放的视频
        video(){
            // 视频分P
            const p = this.$route.query['p'] || 1
            const videos = this.videos
            if(!videos || !videos.length) return {...this.resource};
            const index = p - 1 <  videos.length ? (p - 1) : 0;
            const video = videos[index]
            return {...video}
        },
        itemId(){
            return this.video.itemId || null
        }
    }
}
</script>

<style scoped>
.bottom-20 {
    margin-bottom: 20px;
}

.bottom-30 {
    margin-bottom: 30px;
}

.content {
    padding: 10px;
}

.video-title {
    font-size: 18px;
    font-weight: 600;

}

.title-logo-tri {
    border: 8px solid #fff;
    border-left: 12px solid #3BA0E8;
    width: 0;
    height: 0;
    margin-top: 2.5px;
}

.list-title {
    display: flex;
    font-size: 15px;
    font-weight: 600;
}
</style>
